import type { FeatureFlags } from '~/composables/feature-flags/useFeatureFlag'

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  // Needs to be empty so it wont override the AY definition
  timestamp: '',
  sponsoredTiles: {
    provider: 'affinity',
    tilesCount: 5,
  },
  colorScheme: 'system',
  summaryPage: {
    siderail: {
      topClass: 'top-siderail',
      middleClass: 'middle-siderail',
      bottomClass: 'bottom-siderail',
    },
    content: {
      topClass: 'top-content',
      middleClass: 'mid-content',
      bottomContentAboveButtonClass: 'bottom-content-above-button',
      bottomContentBelowButtonClass: 'bottom-content-below-button',
    },
    bottomClass: 'bottom-of-page',
  },
  layoutSkeleton: {
    name: 'First Layout',
    section: [
      {
        name: 'First Section with no Repeat',
        background: 'secondary',
        titles: [
          { y: 1, type: 'slider' },
          { y: 1, type: 'title', repeat: true },
          { y: 2, type: 'article-group' },
          { y: 2, type: 'title', repeat: true },
          { y: 3, type: 'title', repeat: true },
        ],
        ads: [
          { y: 1, x: -1, classes: 'v8_onenews_homepage_r1_topright no-padding', props: {} },
          { y: 1, x: -3, classes: 'v8_onenews_homepage_r1_c2 no-padding', props: {} },
          { y: 2, x: 1, classes: 'v8_onenews_homepage_r2_c1 no-padding', props: {} },
          { y: 3, x: -1, classes: 'v8_onenews_homepage_r3_right no-padding', props: {} },
        ],
      },
      {
        name: 'Second Section',
        padded: false,
        titles: [{ y: 1, type: 'title', repeat: true }],
        ads: [{ y: 1, x: 1, classes: 'v8_onenews_homepage_r4_c1 no-padding', props: {} }],
      },
      {
        name: 'repeated section',
        repeat: true,
        padded: false,
        titles: [
          { y: 1, type: 'title', repeat: true },
          { y: 2, type: 'title', repeat: true },
          { y: 3, type: 'title', repeat: true },
          { y: 4, type: 'title', repeat: true },
        ],
        ads: [
          { y: 2, x: -1, classes: 'v8_onenews_homepage_endless_right no-padding', props: {} },
          { y: 4, x: 1, classes: 'v8_onenews_homepage_endless_right no-padding', props: {} },
        ],
      },
    ],
  },
}
